module.exports = __webpack_public_path__ + "img/Cranberry Concentrate.2f271d10.png";